import { useStacklineTheme } from '@stackline/ui';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { ExitIconSmall } from 'src/components/SvgIcons';
import CircularProgressWithLabel from 'src/components/common/UploadAnimation/CircularProgressWithLabel';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';

const textStyle = {
  fontFamily: 'Roboto',
  fontSize: '32px',
  fontWeight: 'bold',
  lineHeight: '48px',
  color: colors.darkBlue
};

const BulkTemplateDownloadModalLoadingInner = ({
  closeBulkTemplateDownloadModal,
  downloadPercentage
}: {
  closeBulkTemplateDownloadModal: () => void;
  downloadPercentage: number;
}) => {
  const theme = useStacklineTheme();

  const onCloseBtn = () => {
    closeBulkTemplateDownloadModal();
  };

  return (
    <>
      {/* Header */}
      <Flex
        height="72px"
        alignItems="center"
        justifyContent="center"
        style={{
          borderBottom: '1px solid #E8E8ED',
          flexShrink: 0,
          position: 'relative',
          minHeight: '72px'
        }}
      >
        <Text
          variant="h4"
          sx={{ fontSize: '20px', fontWeight: 700, lineHeight: '28px', letterSpacing: '0.08px' }}
          textAlign="center"
        >
          Download Template
        </Text>
        <ExitIconSmall
          onClick={closeBulkTemplateDownloadModal}
          style={{
            position: 'absolute',
            right: '24px',
            cursor: 'pointer',
            width: '24px',
            height: '24px'
          }}
        />
      </Flex>

      {/* Content */}
      <Flex
        flexDirection="column"
        alignItems="center"
        style={{
          flex: 1,
          paddingTop: '56px'
        }}
      >
        <Flex flexDirection="column" alignItems="center" style={{ width: '423px', gap: '24px' }}>
          <CircularProgressWithLabel
            percentage={downloadPercentage}
            label="Downloaded"
            circleSx={{ color: theme.colors.primary }}
            circleProps={{ size: '240px' }}
            backgroundCircleProps={{ size: '248px' }}
            customLabel={
              <>
                <Flex height="48px" justifyContent="center">
                  <span style={textStyle}>{`${formatMetric(downloadPercentage, METRICTYPE.VOLUME, {
                    showFullValue: true
                  })}%`}</span>
                </Flex>
                <Flex height="28px" justifyContent="center">
                  <Text
                    variant="h4"
                    sx={{ fontSize: '20px', fontWeight: 700, lineHeight: '28px', letterSpacing: '0.08px' }}
                    textAlign="center"
                  >
                    Downloaded
                  </Text>
                </Flex>
              </>
            }
          />

          <Flex flexDirection="column" alignItems="center" style={{ gap: '8px', width: '423px' }}>
            <Text
              variant="h4"
              sx={{
                width: '344px',
                fontSize: '22px',
                fontWeight: 700,
                lineHeight: '36px',
                letterSpacing: '0.08px'
              }}
              textAlign="center"
            >
              Your bulk template is downloading
            </Text>
            <Flex flexDirection="column" alignItems="center" style={{ width: '423px' }}>
              <Text
                variant="body1"
                sx={{
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '24px',
                  letterSpacing: '0.08px',
                  textAlign: 'center'
                }}
                textAlign="center"
              >
                It may take a few minutes for the download to complete.
              </Text>
              <Text
                variant="body1"
                sx={{
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '24px',
                  letterSpacing: '0.08px',
                  textAlign: 'center'
                }}
                textAlign="center"
              >
                You can close this window in the meantime.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      {/* Footer */}
      <Flex
        justifyContent="space-between"
        alignItems="center"
        style={{
          height: '72px',
          minHeight: '72px',
          borderTop: '1px solid #E8E8ED',
          padding: '0 48px',
          flexShrink: 0
        }}
      >
        <SlButton disabled buttonSx={{ width: '72px' }}>
          Back
        </SlButton>
        <SlButton onClick={onCloseBtn} variant="contained" buttonSx={{ width: '76px' }}>
          Close
        </SlButton>
      </Flex>
    </>
  );
};

export default BulkTemplateDownloadModalLoadingInner;
